import React from 'react';
import Retenciones from '../components/impuesto1x500/retencion1x500';

function Retencion() {
  return (
 <Retenciones />
  );
}

export default Retencion;




// WEBPACK FOOTER //
// ./src/pages/retencion1x500.js